// Generated types for ThinkingPart
// This file is auto-generated - do not edit manually

import { z } from 'zod';

import { ResponsePartReadAPI, ResponsePartWriteAPI } from './responsepart';
import { ResponsePartReadAPISchemaObject, ResponsePartWriteAPISchemaObject } from './responsepart';

// ============================================================================
// TypeScript Interfaces
// ============================================================================

export interface ThinkingPartReadAPI extends ResponsePartReadAPI {
  /** The reasoning text */
  content?: string;
  /** Whether this thinking content is being streamed */
  is_streaming?: boolean;
  /** Provider-supplied signature for the thinking part (e.g. Anthropic). */
  signature?: string | null;
  /** Provider that produced the signature (required when signature is set). */
  provider_name?: string | null;
  /** Opaque provider metadata (e.g. Gemini thought_signature). */
  provider_details?: Record<string, unknown> | null;
}

export interface ThinkingPartWriteAPI extends ResponsePartWriteAPI {
  /** The reasoning text */
  content?: string;
  /** Whether this thinking content is being streamed */
  is_streaming?: boolean;
}

// ============================================================================
// Zod Schemas
// ============================================================================

export const ThinkingPartReadAPISchema: z.ZodType<ThinkingPartReadAPI> = ResponsePartReadAPISchemaObject.extend({
  content: z.string().optional(),
  is_streaming: z.boolean().optional(),
  signature: z.string().nullable().optional(),
  provider_name: z.string().nullable().optional(),
  provider_details: z.preprocess((v) => typeof v === 'string' ? (() => { try { return JSON.parse(v); } catch { return v; } })() : v, z.record(z.string(), z.unknown()).nullable()).optional(),
}).passthrough();

export const ThinkingPartWriteAPISchema: z.ZodType<ThinkingPartWriteAPI> = ResponsePartWriteAPISchemaObject.extend({
  content: z.string().optional(),
  is_streaming: z.boolean().optional(),
}).passthrough();
